const state = {
  drawer: false,
  menuDrawer: false,
  disputeDrawer: false,
}

const getters = {
  isDrawerOpen: (state) => state.drawer,
  isMenuDrawerOpen: (state) => state.menuDrawer,
  isDisputeDrawerOpen: (state) => state.disputeDrawer,
}

const mutations = {
  setIsDrawerOpen: (state, status) => {
    state.drawer = status
  },

  setIsMenuDrawerOpen: (state, status) => {
    state.menuDrawer = status
  },

  setIsDisputeDrawerOpen: (state, status) => {
    state.disputeDrawer = status
  },
}

export default {
  state,
  getters,
  mutations,
}
